<template lang="pug">
v-row.my-4.text-center.d-flex.justify-center(no-gutters, v-if="deltaText")
  v-col.d-flex.align-center(cols="2", offset="2")
    v-divider
  v-col.text-center.d-flex.align-center.justify-center(cols="4")
    v-icon(color="darkGrey", :size="16") {{ timeIcon }}
    span.pl-1.pl-sm-2(:style="styles") {{ deltaText }}
  v-col.d-flex.align-center(cols="2")
    v-divider
</template>

<script lang="ts">
import Vue from "vue"
import { mdiClockOutline } from "@mdi/js"
import THEME from "../../constants/theme"
import moment from "moment"
const { fontFamily } = THEME.typography

moment.locale("de")

export default Vue.extend({
  name: "TimeDelta",
  props: {
    currDateTime: { type: String, required: true },
    prevDateTime: { type: String, required: true },
  },
  data() {
    return {
      timeIcon: mdiClockOutline,
    }
  },
  computed: {
    isXsScreenSize(): boolean {
      return this.$vuetify.breakpoint.name === "xs"
    },
    styles(): object {
      return {
        color: this.$vuetify.theme.themes.light.darkGrey,
        fontWeight: 400,
        fontFamily: fontFamily,
        fontSize: `${this.isXsScreenSize ? 0.75 : 0.8}rem`,
      }
    },
    weeksDelta(): number {
      return Math.floor(
        moment
          .duration(moment(this.currDateTime).diff(moment(this.prevDateTime)))
          .asWeeks()
      )
    },
    monthsDelta(): number {
      return Math.floor(
        moment
          .duration(moment(this.currDateTime).diff(moment(this.prevDateTime)))
          .asMonths()
      )
    },
    yearsDelta(): number {
      return Math.floor(
        moment
          .duration(moment(this.currDateTime).diff(moment(this.prevDateTime)))
          .asYears()
      )
    },
    deltaText(): string | null {
      if (this.yearsDelta === 1) return `${this.yearsDelta} Jahr später`
      if (this.yearsDelta >= 1) return `${this.yearsDelta} Jahre später`
      if (this.monthsDelta === 1) return `${this.monthsDelta} Monat später`
      if (this.monthsDelta >= 1) return `${this.monthsDelta} Monate später`
      if (this.weeksDelta === 1) return `${this.weeksDelta} Woche später`
      if (this.weeksDelta >= 1) return `${this.weeksDelta} Wochen später`
      return null
    },
  },
})
</script>
